export class Margin {
  constructor(
    public top: number,
    public right: number,
    public bottom: number,
    public left: number,
  ) {
  }
}
